// extracted by mini-css-extract-plugin
export default {"specialization-block":"specialization-block__Z2Sph"};